export default function initFilterAndSort() {
    const filterButtons = document.querySelectorAll(".filters__types button");
    const sortSelect = document.querySelector(".filters__sort select");
    const list = document.getElementById("articles-list");

    if (!list) return;
    if (!filterButtons.length) return;
    if (!sortSelect) return;

    const items = Array.from(list.querySelectorAll("li.paginated-item"));
    if (!items.length) return;

    const pageSize = parseInt(list.dataset.pageSize, 10) || 10;

    let activeCategory = "all";
    let sortOrder = sortSelect.value;

    // Hide reviews immediately on first load (prevents flash)
    items.forEach(item => {
        if ((item.dataset.category || "").toLowerCase() === "reviews") {
            item.style.display = "none";
        }
    });

    function applyFilters() {
        let filtered;

        if (activeCategory === "all") {
            filtered = items.filter(item =>
                (item.dataset.category || "").toLowerCase() !== "reviews"
            );
        } else {
            filtered = items.filter(item =>
                (item.dataset.category || "").toLowerCase() === activeCategory
            );
        }

        const getTime = (el) => {
            const t = Date.parse(el.dataset.date);
            return Number.isNaN(t) ? 0 : t;
        };

        filtered.sort((a, b) => {
            const dateA = getTime(a);
            const dateB = getTime(b);

            return sortOrder === "latest"
                ? (dateB - dateA)
                : (dateA - dateB);
        });

        let ordered;

        if (activeCategory === "all") {
            ordered = [...filtered];
        } else {
            const rest = items.filter(i => !filtered.includes(i));
            ordered = [...filtered, ...rest];
        }

        const frag = document.createDocumentFragment();
        ordered.forEach(li => frag.appendChild(li));
        list.appendChild(frag);

        items.forEach(item => item.style.display = "none");

        filtered.slice(0, pageSize).forEach(item => {
            item.style.display = "block";
        });

        rebuildPagination(filtered);
    }

    function rebuildPagination(filteredItems) {
        const pagination = document.getElementById("pagination");
        if (!pagination) return;

        const totalPages = Math.ceil(filteredItems.length / pageSize);
        pagination.innerHTML = "";

        let currentPage = 1;

        const goToPage = (page) => {
            currentPage = Math.max(1, Math.min(totalPages, page));

            items.forEach(item => item.style.display = "none");

            const start = (currentPage - 1) * pageSize;
            const end = start + pageSize;

            filteredItems.slice(start, end).forEach(item => {
                item.style.display = "block";
            });

            pagination.querySelectorAll(".page-btn").forEach(b => b.classList.remove("--active"));
            const activeBtn = pagination.querySelector(`.page-btn[data-page="${currentPage}"]`);
            if (activeBtn) activeBtn.classList.add("--active");

            prev.disabled = currentPage === 1;
            next.disabled = currentPage === totalPages;
        };

        const prev = document.createElement("button");
        prev.type = "button";
        prev.className = "btn";
        prev.id = "prev-page";
        prev.innerHTML = `<i class="far fa-chevron-left"></i>`;
        prev.addEventListener("click", () => goToPage(currentPage - 1));
        pagination.appendChild(prev);

        for (let i = 1; i <= totalPages; i++) {
            const btn = document.createElement("button");
            btn.type = "button";
            btn.className = "btn page-btn" + (i === 1 ? " --active" : "");
            btn.dataset.page = i;
            btn.textContent = i;

            btn.addEventListener("click", () => goToPage(i));
            pagination.appendChild(btn);
        }

        const next = document.createElement("button");
        next.type = "button";
        next.className = "btn";
        next.id = "next-page";
        next.innerHTML = `<i class="far fa-chevron-right"></i>`;
        next.addEventListener("click", () => goToPage(currentPage + 1));
        pagination.appendChild(next);

        goToPage(1);
    }

    filterButtons.forEach(btn => {
        btn.addEventListener("click", () => {
            filterButtons.forEach(b => b.classList.remove("--active"));
            btn.classList.add("--active");

            activeCategory = btn.dataset.category.toLowerCase();
            applyFilters();
        });
    });

    sortSelect.addEventListener("change", () => {
        sortOrder = sortSelect.value;
        applyFilters();
    });

    // Trigger the "All" filter AFTER listeners are attached
    window.requestAnimationFrame(() => {
        const allBtn = document.querySelector('.filters__types button[data-category="all"]');
        if (allBtn) allBtn.click();
    });
}